import {
  BillAccountCanRegister,
  initialBillAccountCanRegister
} from '../models/bill-account-can-register.models';
import {
  BillAccountCanRegisterAction,
  CAN_REGISTER,
  CAN_REGISTER_CLEAR,
  CAN_REGISTER_FAIL,
  CAN_REGISTER_SUCCESS
} from './bill-account-can-register.actions';

// This reduces a set of registrations
export function billAccountCanRegisterReducer(
  state = initialBillAccountCanRegister,
  action: BillAccountCanRegisterAction
): BillAccountCanRegister {
  switch (action.type) {
    case CAN_REGISTER:
      return { ...state, ...initialBillAccountCanRegister, ...action.payload, loading: true };

    case CAN_REGISTER_CLEAR:
      return { ...state, ...initialBillAccountCanRegister };

    case CAN_REGISTER_SUCCESS:
      // AS: Get the policy number from the response payload and override the policy number of state(request payload)
      // with the policy number in response payload which might include the needed "check digits"
      // eslint-disable-next-line no-case-declarations
      const policyObj = (action.payload.billingAccount.policyList ?? []).find(
        policyObjFromResponse =>
          policyObjFromResponse.policyNumber.substring(0, 10) ===
          state.policyNumber?.substring(0, 10)
      );
      return {
        ...state,
        ...action.payload,
        policyNumber: policyObj ? policyObj.policyNumber : state.policyNumber,
        loading: false,
        loaded: true
      };

    case CAN_REGISTER_FAIL:
      return { ...state, ...(action.payload as object), loading: false, loaded: true };

    default:
      return state;
  }
}
